export default __webpack_public_path__ + "static/cCWWUvED-a5787671cc188b3c7186f12b9c120e9e.svg";